/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capability_Denied_TooltipInputs */



/**
* | output |
* | --- |
* | "Your administrator has not enabled this for you." |
*
* @param {Capability_Denied_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const capability_denied_tooltip = /** @type {((inputs?: Capability_Denied_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capability_Denied_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Funktion hat dir deine Administration nicht freigeschaltet.")
	return /** @type {LocalizedString} */ ("Your administrator has not enabled this for you.")
});